import React from "react";
import { Phone } from "lucide-react";

const EmergencyContacts = ({ 
  contacts = [], 
  title = "Emergency Contacts" 
}) => {
  return (
    <div className=" p-2 w-full max-w-md mx-auto">
      {/* Title */}
      <h3 className="text-base sm:text-lg font-semibold text-black mb-3">
        {title}
      </h3>

      {/* Contacts List */}
      {contacts.length > 0 ? (
        <div className="space-y-2">
          {contacts.map((contact, index) => (
            <div
              key={index}
              className="flex items-center text-sm sm:text-base text-black"
            >
              <Phone className="w-4 h-4 sm:w-5 sm:h-5 mr-2 text-black" />
              <span className="font-medium">{contact.label}:</span>
              <span className="ml-1">{contact.number}</span>
            </div>
          ))}
        </div>
      ) : (
        <p className="text-black text-sm">No contacts available</p>
      )}
    </div>
  );
};

export default EmergencyContacts;
